import React from 'react';
import './PrivacyView.less';
import { Link } from 'react-router';

type Props = {

}

class PrivacyView extends React.Component {

  description: 'Shows the privacy policy.'

  props: Props

  constructor(props: Props) {
    super(props);
  }

  /* Component Custom Methods */
  /* End Component Custom Methods */

  /* React Component LifeCycle Methods */
  //componentWillMount() {}
  //componentDidMount() {}
  //componentWillReceiveProps(nextProps) {}
  //shouldComponentUpdate(nextProps, nextState) {}
  //componentWillUpdate(nextProps, nextState) {}
  //componentDidUpdate(prevProps, prevState) {}
  //componentWillUnmount() {}
  render() {
    return (
      <div className="privacy-view">
        <div className="bloc-small m-t-xl m-b-xl">
          <h1 className="m-t-xl m-b-xl txt-center">Privacy Policy</h1>
          <h3 className="m-t-xxl m-b">SECTION 1 - WHAT DO WE DO WITH YOUR INFORMATION?</h3>

          <p>When you contact us through our contact form, we collect the personal information you give us such as your name, and email address.When you browse our store, we also automatically receive your computer’s internet protocol (IP) address in order to provide us with information that helps us learn about your browser and operating system.</p>

          <h3 className="m-t-xxl m-b">SECTION 2 - CONSENT</h3>

          <h4 className="m-t m-b">How do you get my consent?</h4>

          <p>When you provide us with personal information to complete the contact form, we imply that you consent to our collecting it and using it for that specific reason only.</p>

          <p>If we ask for your personal information for a secondary reason, like marketing, we will either ask you directly for your expressed consent, or provide you with an opportunity to say no.</p>

          <h4 className="m-t m-b">How do I withdraw my consent?</h4>

          <p>If after you opt-in, you change your mind, you may withdraw your consent for usto contact you, for the continued collection, use or disclosure of your information, at anytime, by contacting us through the <Link to="/contact" >form</Link>.</p>

          <h3 className="m-t-xxl m-b">SECTION 3 - DISCLOSURE</h3>

          <p>We may disclose your personal information if we are required by law to do so or if you violate our Terms of Service.</p>

          <h3 className="m-t-xxl m-b">SECTION 4 – WORLD SPACE SCHOOL</h3>

          <p>Your data is stored through World Space School’s data storage, databases and the general World Space School application.</p>

          <h3 className="m-t-xxl m-b">SECTION 5 - THIRD-PARTY SERVICES</h3>

          <p>In general, the third-party providers used by us will only collect, use and disclose your information to the extent necessary to allow them to perform the services they provide to us.</p>

          <p>In particular, remember that certain providers may be located in or have facilities that are located in a different jurisdiction than either you or us.So if you elect to proceed with a transaction that involves the services of a third-party service provider, then your information may become subject to the laws of the jurisdiction(s) in which that service provider or its facilities are located.</p>

          <p>As an example, if you are located in Canada and your transaction is processed by a payment gateway located in the United States, then your personal information used in completing that transaction may be subject to disclosure under United States legislation, including the Patriot Act.</p>

          <p>Once you leave our website or are redirected to a third-party website or application, you are no longer governed by this Privacy Policy.</p>

          <h4 className="m-t m-b">Links</h4>

          <p>When you click on links on our service, they may direct you away from our site.We are not responsible for the privacy practices of other sites and encourage you to read their privacy statements.</p>

          <h3 className="m-t-xxl m-b">SECTION 6 - SECURITY</h3>

          <p>To protect your personal information, we take reasonable precautions and follow industry best practices to make sure it is not inappropriately lost, misused, accessed, disclosed, altered or destroyed.</p>

          <p>If you provide us your information, the information is encrypted using secure socket layer technology (SSL).Although no method of transmission over the Internet or electronic storage is 100% secure, we implement generally accepted industry standards.</p>

          <h3 className="m-t-xxl m-b">SECTION 7 - AGE OF CONSENT</h3>

          <p>By using this site, you represent that you are at least the age of majority in your state or province of residence, or that you are the age of majority in your state or province of residence and you have given us your consent to allow any of your minor dependents to use this site.</p>

          <h3 className="m-t-xxl m-b">SECTION 8 - CHANGES TO THIS PRIVACY POLICY</h3>

          <p>We reserve the right to modify this privacy policy at any time, so please review it frequently.Changes and clarifications will take effect immediately upon their posting on the website.If we make material changes to this policy, we will notify you here that it has been updated, so that you are aware of what information we collect, how we use it, and under what circumstances, if any, we use and/or disclose it.</p>

          <h3 className="m-t-xxl m-b">QUESTIONS AND CONTACT INFORMATION</h3>

          <p>If you would like to: access, correct, amend or delete any personal information we have about you, register a complaint, or simply want more information contact us through the <Link to="/contact" >form</Link>.</p>
        </div>
      </div>
    );
  }
  /* End React Component LifeCycle Methods */
}

export default PrivacyView;

//Unit test entry point
export const PrivacyViewTest = PrivacyView;


/** WEBPACK FOOTER **
 ** ./src/js/views/PrivacyView/PrivacyView.jsx
 **/